<div class="container-fluid">
    <app-breadcrumb
        [title]="'Suivi des opérations'"
        [active_item]="'Performances SLA'"
    ></app-breadcrumb>
    <div class="card" [ngStyle]="{ 'border-radius': '10px' }">
        <div class="card-body">
            <div class="row filter_wrapper">
                <div class="col-md-2">
                    <div class="form-group">
                        <label><b>Type opération</b></label>
                        <p-dropdown
                            [options]="listOperations"
                            [showClear]="true"
                            [(ngModel)]="selectedTypeOperation"
                            placeholder="Opération"
                        >
                            <ng-template let-data pTemplate="item">
                                <div class="country-item">
                                    <div>{{ data | titlecase }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>
                            <b>{{ firstLevelLibelle }}</b>
                        </label>
                        <p-dropdown
                            [options]="listFirstLevel"
                            optionLabel="fullName"
                            (onChange)="onChangeItem($event)"
                            [showClear]="true"
                            [filter]="true"
                            filterBy="fullName"
                            [placeholder]="firstLevelLibelle"
                        >
                            <ng-template let-data pTemplate="item">
                                <div class="country-item">
                                    <div>
                                        {{ data.fullName }}
                                    </div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>
                            <b>{{ secondLevelLibelle }}</b>
                        </label>
                        <p-dropdown
                            [options]="listSecondLevel"
                            optionLabel="fullName"
                            optionLabel="nom"
                            [filter]="true"
                            [(ngModel)]="selectedSecondLevel"
                            [showClear]="true"
                            [placeholder]="secondLevelLibelle"
                        >
                            <ng-template let-data pTemplate="item">
                                <div class="country-item">
                                    <div>
                                        {{ data.fullName }}
                                    </div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label><b>N° Ligne</b> </label>
                        <input
                            type="text"
                            pInputText
                            [(ngModel)]="selectedTransaction"
                        />
                    </div>
                </div>
                <div class="p-0" [ngStyle]="{ width: '4rem' }">
                    <label [ngStyle]="{ opacity: '0' }">Actions</label> <br />
                    <p-button
                        styleClass="p-button-success"
                        icon="pi pi-filter"
                        (click)="onFilter()"
                        [disabled]="isFilter()"
                    ></p-button>
                </div>
            </div>
            <div class="mt-4">
                <p-table
                    #dt
                    [value]=""
                    [rows]="10"
                    [paginator]="true"
                    [globalFilterFields]="['id', 'operation', 'transaction']"
                    responsiveLayout="scroll"
                    [rowHover]="true"
                    dataKey="id"
                    currentPageReportTemplate="Affichage de {first} à {last} des {totalRecords} données"
                    [showCurrentPageReport]="true"
                    responsiveLayout="scroll"
                    scrollable="true"
                    scrollHeight="flex"
                    width="100%"
                    class="responsive-claims-table"
                >
                    <ng-template pTemplate="caption">
                        <div class="seach_and_btns" style="margin-top: 1.5rem">
                            <div>
                                <button
                                    pButton
                                    pRipple
                                    label="Rafraîchir"
                                    icon="pi pi-refresh"
                                    class="p-button-secondary"
                                ></button>
                                <button
                                    pButton
                                    pRipple
                                    label="Exporter"
                                    icon="pi pi-download"
                                    class="p-button-helf ms-3"
                                ></button>
                            </div>
                            <div>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        (input)="
                                            dt.filterGlobal(
                                                $event.target.value,
                                                'contains'
                                            )
                                        "
                                        placeholder="Recherche..."
                                    />
                                </span>
                            </div>
                        </div>
                    </ng-template>
                    <br />
                    <ng-template pTemplate="header">
                        <tr>
                            <th>#</th>
                            <th>Operation</th>
                            <th># Total Ligne</th>
                            <th># Opérations clôturées</th>
                            <th># Opérations en cours</th>
                            <th># Demandes</th>
                            <th>
                                DMT (Heure)
                                <span
                                    style="
                                        position: relative;
                                        top: 0.2rem;
                                        cursor: pointer;
                                    "
                                    ><i
                                        class="pi pi-info-circle"
                                        (click)="showInfos('dmt')"
                                    ></i
                                ></span>
                            </th>
                            <th># Delais OK</th>
                            <th>% Delais OK</th>
                            <th>
                                SLA (Heure)
                                <span
                                    style="
                                        position: relative;
                                        top: 0.2rem;
                                        cursor: pointer;
                                    "
                                    ><i
                                        class="pi pi-info-circle"
                                        (click)="showInfos('sla')"
                                    ></i
                                ></span>
                            </th>
                            <th>Graphe</th>
                        </tr>
                    </ng-template>
                    <ng-template let-i="rowIndex" pTemplate="body" let-prise>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
